// The `id` of each status is the API value and must never be translated; the
// labels are resolved at call time so they follow the active language.
export const SUBSCRIPTION_STATUS_TONE = {
  active: "success",
  canceled: "error",
  pending: "alert",
  unknown: "neutral",
};

export const getSubscriptionStatuses = (t) => [
  { id: "active", label: t("membersList.subscriptionStatuses.active"), tone: "success" },
  { id: "canceled", label: t("membersList.subscriptionStatuses.canceled"), tone: "error" },
  { id: "pending", label: t("membersList.subscriptionStatuses.pending"), tone: "alert" },
  { id: "unknown", label: t("membersList.subscriptionStatuses.unknown"), tone: "neutral" },
];

export const getSubscriptionStatusLabels = (t) =>
  getSubscriptionStatuses(t).reduce(
    (acc, status) => ({ ...acc, [status.id]: status.label }),
    {}
  );
